import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const l = e((a, c) => /* @__PURE__ */ s.jsx(
  h,
  {
    ref: c,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3697",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M4.7 5.22a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M11.3 5.22a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M13 .8h-.94V.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75V.8H5.44V.75a.749.749 0 1 0-1.5 0V.8H3c-1.65 0-3 1.35-3 3V13c0 1.65 1.35 3 3 3h10c1.65 0 3-1.35 3-3V3.8c0-1.65-1.35-3-3-3M3 2.3h.95c.02.4.34.71.74.71s.73-.31.75-.71h5.13a.743.743 0 0 0 1.48 0H13c.83 0 1.5.67 1.5 1.5v2.39h-13V3.8c0-.83.67-1.5 1.5-1.5m10 12.2H3c-.83 0-1.5-.67-1.5-1.5V7.69h13V13c0 .83-.67 1.5-1.5 1.5"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M5.59 8.22c-1.17 0-2.09 1.26-2.09 2.87s.92 2.87 2.09 2.87 2.09-1.26 2.09-2.87-.92-2.87-2.09-2.87m0 4.25c-.17 0-.59-.48-.59-1.37s.42-1.37.59-1.37.59.48.59 1.37-.42 1.37-.59 1.37M11.75 12.47h-.59V8.96c0-.05-.02-.1-.03-.15s-.02-.1-.04-.14a.2.2 0 0 0-.05-.07c-.04-.06-.07-.11-.12-.16-.01-.01-.02-.01-.03-.02a.7.7 0 0 0-.22-.13c-.01 0-.02 0-.04-.01-.07-.02-.14-.04-.22-.04-.01 0-.02.01-.03.01-.03 0-.06.01-.09.02-.07.01-.13.02-.19.05-.02.01-.03.02-.04.03-.07.02-.14.06-.19.12-.02.01-.03.04-.04.06-.04.05-.09.11-.11.18 0 .01-.01.01-.01.02-.01.02-.21.53-.63.53-.41 0-.75.34-.75.75s.34.75.75.75c.21 0 .41-.04.59-.09v1.8h-.59c-.41 0-.75.34-.75.75s.34.75.75.75h2.67c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3697)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
l.displayName = "AgencyCalendarIcon";
export {
  l as AgencyCalendarIcon,
  l as default
};
//# sourceMappingURL=index.js.map
